var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("app-browse", {
        attrs: {
          "controls-disabled": false,
          "data-source": _vm.dataSource,
          "edit-buttons-hidden": "",
          "selected-items": _vm.selectedItems,
          "button-bar-items": _vm.buttonBarItems,
        },
      }),
      _vm.createDataModal
        ? _c("app-create-bookkeeping-data-modal", {
            on: {
              close: function ($event) {
                _vm.createDataModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }